import { createFileRoute, Outlet } from "@tanstack/react-router";
import NotFoundPage from "@/catchall";
import { useAuth } from "@/auth/use-auth";

// This is for shared components between patient 360 and pharmacy 360 like the product pages
export const Route = createFileRoute("/_private/_patient-pharmcy-360")({
  component: PatientPharmacyLayout,
});

function PatientPharmacyLayout() {
  const { authUser } = useAuth();

  if (
    authUser?.permissions?.includes("patient_360") ||
    authUser?.permissions?.includes("pharmacy_360")
  ) {
    return <Outlet />;
  } else {
    return <NotFoundPage />;
  }
}
